import React                                from 'react';
import classNames                           from 'classnames';
import { WithStyle }                        from 'rewire-ui';
import { Theme }                            from '@material-ui/core/styles';
import Typography                           from '@material-ui/core/Typography';
import Icon                                 from '@material-ui/icons/Brightness1';
import { ExportStatusType, toExportStatus } from '../DataTypes';
import { withStyles }                       from '../utility/styles';


const styles = (_theme: Theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    height: '16px',
    width: '16px',
    alignSelf: 'center',
  },
  notExported: {
    color: 'darkorange',
  },
  exported: {
    color: 'green'
  }
});

interface IExportLabelProps {
  className?:  string;
  exportStatus: ExportStatusType;
  exportName?:  string;
  showLabel?:  boolean;
}

type ExportLabelProps = WithStyle<ReturnType<typeof styles>, IExportLabelProps>;

class ExportStatusLabel extends React.PureComponent<ExportLabelProps> {
  ExportClass(exportStatus: ExportStatusType, classes: any): string {
    switch (exportStatus) {
      case 'not_exported': return classes.notExported;
      case 'exported':     return classes.exported;
    }
  }

  ExportLabel(ExportStatus: ExportStatusType, ExportName?: string) {
    if (!ExportName || (ExportStatus === 'not_exported')) return toExportStatus(ExportStatus);

    return `${ExportName}: ${toExportStatus(ExportStatus)}`;
  }

  render() {
    const { classes, className, exportStatus, exportName, showLabel } = this.props;
    const ExportClass                                                 = this.ExportClass(exportStatus, classes);
    const ExportLabel                                                 = showLabel ? this.ExportLabel(exportStatus, exportName) : null;

    if (!exportStatus) return null;

    return <Typography display='inline' variant='button' className={classNames(className, classes.root)}><Icon className={classNames(classes.icon, ExportClass)} />&nbsp;<span className={ExportClass}>{ExportLabel}</span></Typography>;
  }
}

export default withStyles<IExportLabelProps>(styles, ExportStatusLabel);